import { MoneyPatternType } from '@dreryk/react-common';
import { MoneyInput, StyledMaxWidth } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../../translations';
import { ReceptionServiceFormController } from '../../../ReceptionServiceForm';

import { getDefaultValue } from './ReceptionServiceAdvancePaymentAmountInputField.utils';

const MIN_ADVANCE_PAYMENT_VALUE = 1;
const MAX_ADVANCE_PAYMENT_VALUE = 999999.99;

type ReceptionServiceAdvancePaymentAmountInputFieldProps = Pick<ReceptionServiceFormController, 'register' | 'watch'>;

export const ReceptionServiceAdvancePaymentAmountInputField = (
   props: ReceptionServiceAdvancePaymentAmountInputFieldProps
): JSX.Element => {
   const bean = props.watch();

   return (
      <StyledMaxWidth maxWidth={133}>
         <MoneyInput
            controller={props.register('advancePaymentAmount', { required: true })}
            defaultValue={getDefaultValue(bean)}
            label={receptionServiceTranslationKeys.shared.form.components.advancePaymentAmountInput.label}
            min={MIN_ADVANCE_PAYMENT_VALUE}
            max={MAX_ADVANCE_PAYMENT_VALUE}
            pattern={MoneyPatternType.POSITIVE}
            testId={'advancePaymentAmount'}
         />
      </StyledMaxWidth>
   );
};
